import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manager';

const list = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}/branchBusHours`, {
		branchId,
		status: 1,
	});
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/branchBusHours/${id}`);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/branchBusHours`, payload);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/branchBusHours/${id}`, payload);
};

const remove = (merchantId, id) => {
	return Client.del(`${baseUrl}/${merchantId}/branchBusHours/${id}`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
